export const co = 10;
export const phoneType = "MOBILE";
export const dateFormat = "yyyy-MM-DD";

export const orderType: any = {
  PERSONALIZED: "Personalized",
  NON_PERSONALIZED: "Non-Personalized",
};

export const orderStatusColor: any = {
  confirmed: "green",
  processed: "green",
  scheduled: "yellow",
  printing: "yellow",
  "in-progress": "yellow",
  partially_completed: "yellow",
  inprogress: "yellow",
  resumed: "red",
  declined: "red",
  incomplete: "red",
  failed: "red",
  canceled: "red",
  cancelled: "red",
};

export const cardStatusColor: any = {
  open: "green",
  new: "green",
  block: "red",
  reissued: "yellow",
  blocked: "red",
  "fraud block": "red",
  "fraud blocked": "red",
  fraud_blocked: "red",
  close: "red",
  closed: "red",
};

export const ordererdCardStatusColor: any = {
  open: "green",
  new: "green",
  purchased: "green",
  "re-issued": "yellow",
  blocked: "red",
  fraud_blocked: "red",
  close: "red",
  lost: "red",
  stolen: "red",
  expired: "red",
  closed: "red",
};

export const affiliateStatusColor: any = {
  NEW: "blue",
  PENDING_DOCS: "yellow",
  RESUBMIT_DETAILS: "yellow",
  UNDER_REVIEW: "purple",
  READY_FOR_APPROVAL: "blue",
  APPROVED: "green",
  DECLINED: "red",
  BLOCKED: "red",
  CLOSED: "red",
  DEFAULT: "blue",
};

export const SIGNATURE_EXPIRE_ERROR_CODE = "403001";
export const TOKEN_DECODE_ERROR_CODE = "401001";
